export const settingsData = {
title:"Einstellungen"
};